import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithProgress } from 'src/helpers/fetchQueryHelper';
import {
  TourProgressResponse,
  TourProgressUpdateRequest,
  // TpiTourData,
} from '@typeRoots/common/tourProgress';

/**
 * Tour Progress API
 * Handles fetching and updating user tour completion state
 */
export const tourApi = createApi({
  reducerPath: 'tourApi',
  baseQuery: baseQueryWithProgress,
  tagTypes: ['TourProgress'],

  endpoints: (builder) => ({
    /**
     * Get tour progress for current user
     * Backend auto-creates record with all fields = false if doesn't exist
     */
    getTourProgress: builder.query<TourProgressResponse, void>({
      query: () => ({
        url: '/tour-progress?applicationId=tpi',
        method: 'GET',
      }),
      providesTags: ['TourProgress'],
    }),

    /**
     * Update tour progress (delta merge)
     * Only send fields you want to update - backend merges with existing data
     *
     * @example
     * updateTourProgress({ tourData: { companyStart: true } })
     */
    updateTourProgress: builder.mutation<TourProgressResponse, TourProgressUpdateRequest>({
      query: (body) => ({
        url: '/tour-progress?applicationId=tpi',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['TourProgress'],
    }),
  }),
});

export const { useGetTourProgressQuery, useUpdateTourProgressMutation } = tourApi;
